export default __webpack_public_path__ + "static/media/website.7f948ac2.png";